import ServiceFactory from "@/services/service.factory";

const fileService = ServiceFactory.create("file");

export default class Message {
  constructor (data) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }

  async translateImagesToWithAbsolutePath () {
    if (!this.images) {
      return [];
    }

    this.images = await Promise.all(
      // eslint-disable-next-line
      this.images.map(async el => await fileService.get(el))
    );
  }
  async translateFilesToWithAbsolutePath () {
    if (!this.files) {
      return [];
    }

    this.files = await Promise.all(
      // eslint-disable-next-line
      this.files.map(async el => await fileService.get(el))
    );
  }
  static async fromJson (json) {
    const message = new Message(json);
    await message.translateImagesToWithAbsolutePath();
    return message;
  }
}
